import type { ApplyPaymentRequest, ApplyPaymentResponse } from '@/types/payment.types';
import { GenericErrorResponse } from '@brainvaulttech/dgr-react-sdk';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';

export const applyPaymentApi = async (data: ApplyPaymentRequest): Promise<ApplyPaymentResponse> => {
  const response = await axios.post<ApplyPaymentResponse>('/payments/apply', data);
  return response.data;
};

export const useApplyPayment = (
  options?: Omit<UseMutationOptions<ApplyPaymentResponse, GenericErrorResponse, ApplyPaymentRequest>, 'mutationFn'>
) => {
  return useMutation<ApplyPaymentResponse, GenericErrorResponse, ApplyPaymentRequest>({
    mutationFn: applyPaymentApi,
    ...options,
  });
};

